// Purchase panel controller. Prices are computed from cents carried on each
// option and rendered through the shop's own money format, so the totals shown
// here cannot drift from what the cart charges.
(function () {
  // Storefront events. Shopify's standard events (page and product views,
  // add to cart, checkout, purchase) already fire from the platform, so only
  // the choices it cannot see are published here. Shopify.analytics.publish
  // feeds Customer Events, which applies the visitor's consent before any
  // pixel receives them; the DOM event is for on-page listeners.
  window.vxTrack = function (name, data) {
    data = data || {};
    document.dispatchEvent(new CustomEvent('vitelyn:track', { detail: { name: name, data: data } }));
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('vitelyn_' + name, data);
    } catch (e) {}
  };

  function formatMoney(cents, format) {
    var value = cents / 100;

    function withDelims(num, thousands, decimal, places) {
      var fixed = num.toFixed(places);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDelims(value, ',', '.', 2);
        case 'amount_no_decimals': return withDelims(value, ',', '.', 0);
        case 'amount_with_comma_separator': return withDelims(value, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return withDelims(value, "'", '.', 2);
        case 'amount_no_decimals_with_space_separator': return withDelims(value, ' ', ',', 0);
        case 'amount_with_space_separator': return withDelims(value, ' ', ',', 2);
        default: return '';
      }
    });
  }

  // The store's money_format is always the shop currency (EUR). A visitor in
  // another market (US -> USD) sees Liquid prices in their own currency, so
  // the browser copies the format from a sample Shopify rendered for them:
  // "$1,234.56", "€1.234,56", "1 234,56 €" all map to a working formatter.
  function fromSample(sample) {
    var m = sample && sample.match(/\d[\d.,'\u00a0\u202f ]*\d/);
    if (!m) return null;
    var run = m[0];
    var dec = run.length > 3 && /[.,]/.test(run.charAt(run.length - 3)) ? run.charAt(run.length - 3) : '';
    var intPart = dec ? run.slice(0, run.length - 3) : run;
    var thou = (intPart.match(/[^\d]/) || [''])[0];
    var places = dec ? 2 : 0;
    return function (cents) {
      var fixed = (cents / 100).toFixed(places).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return sample.replace(run, fixed[1] ? whole + dec + fixed[1] : whole);
    };
  }

  // Shared with cart-drawer.js so every price on the page uses one formatter.
  // format may be a Shopify money_format string or a rendered sample.
  window.vxMoney = function (cents, format, sample) {
    var f = fromSample(sample);
    return f ? f(cents) : formatMoney(cents, format);
  };

  function init(root) {
    var format = root.dataset.moneyFormat || '${{amount}}';
    var sample = root.dataset.moneySample;
    var max = parseInt(root.dataset.max, 10) || 6;
    var servings = parseInt(root.dataset.servings, 10) || 0;

    var options = Array.prototype.slice.call(root.querySelectorAll('[role="radio"][data-plan]'));
    var planInput = root.querySelector('[data-selling-plan]');
    var qtyInput = root.querySelector('[data-qty]');
    var down = root.querySelector('[data-qty-down]');
    var up = root.querySelector('[data-qty-up]');
    var totalEl = root.querySelector('[data-total]');
    var totalLabel = root.querySelector('[data-total-label]');
    var addTotal = root.querySelector('[data-add-total]');
    var perServing = root.querySelector('[data-per-serving]');
    var totalWas = root.querySelector('[data-total-was]');
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var subTerms = root.querySelector('[data-sub-terms]');
    var product = root.dataset.product;

    // With one purchase option there is no radiogroup to click, just a priced
    // block. Fall back to it so totals and per-serving still compute.
    if (!options.length) {
      var single = root.querySelector('[data-price]');
      if (single && qtyInput) options = [single];
    }

    if (!options.length || !qtyInput) return;

    var unit = 0;
    var plan = '';
    var pct = 0;

    // Bundle discounts apply to one-time purchases only (that is how the
    // automatic discounts are set up), so a subscription shows no tier saving.
    // Shopify takes the percentage off each unit and rounds that saving
    // down to the cent; build the total the same way so it matches the bag.
    function tierTotal(n, tierPct) {
      var p = plan ? 0 : tierPct;
      return n * (unit - Math.floor(unit * p / 100));
    }

    function render() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      if (qty < 1) qty = 1;
      if (qty > max) qty = max;
      qtyInput.value = qty;

      if (down) down.disabled = qty <= 1;
      if (up) up.disabled = qty >= max;

      var total = tierTotal(qty, pct);
      var full = unit * qty;
      if (totalEl) totalEl.textContent = window.vxMoney(total, format, sample);
      if (addTotal) addTotal.textContent = window.vxMoney(total, format, sample);
      if (totalWas) {
        totalWas.hidden = total >= full;
        totalWas.textContent = total < full ? window.vxMoney(full, format, sample) : '';
      }
      if (perServing && servings > 0) {
        perServing.textContent = window.vxMoney(total / qty / servings, format, sample) + (perServing.dataset.suffix || ' per serving');
      }
      tiers.forEach(function (t) {
        var n = parseInt(t.dataset.tier, 10) || 1;
        var tp = parseInt(t.dataset.pct, 10) || 0;
        var tt = tierTotal(n, tp);
        var each = t.querySelector('[data-tier-each]');
        var save = t.querySelector('[data-tier-save]');
        t.querySelector('[data-tier-total]').textContent = window.vxMoney(tt, format, sample);
        if (each) each.textContent = (each.dataset.template || '%').replace('%', window.vxMoney(Math.round(tt / n), format, sample));
        // Per-bottle only says something when it differs from the plain price.
        if (each) each.hidden = plan !== '' || tp === 0;
        if (save) save.hidden = plan !== '' || tp === 0;
      });
    }

    function selectTier(t, fromUser) {
      tiers.forEach(function (o) { o.setAttribute('aria-checked', o === t ? 'true' : 'false'); });
      qtyInput.value = t.dataset.tier;
      pct = parseInt(t.dataset.pct, 10) || 0;
      render();
      if (fromUser) window.vxTrack('bundle_selected', { product: product, quantity: +t.dataset.tier, discount_pct: plan ? 0 : pct });
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () { selectTier(t, true); });
    });

    function select(btn, fromUser) {
      options.forEach(function (o) {
        // Only real radio options carry aria-checked; the single-price block
        // is presentational and must not.
        if (o.getAttribute('role') === 'radio') o.setAttribute('aria-checked', o === btn ? 'true' : 'false');
      });

      plan = btn.dataset.plan || '';
      unit = parseInt(btn.dataset.price, 10) || 0;
      if (subTerms) subTerms.hidden = !plan;

      if (planInput) {
        if (plan) {
          planInput.value = plan;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }
      if (totalLabel && totalLabel.dataset.recurring && totalLabel.dataset.oneTime) {
        totalLabel.textContent = plan ? totalLabel.dataset.recurring : totalLabel.dataset.oneTime;
      }
      render();
      if (fromUser) window.vxTrack(plan ? 'subscription_selected' : 'one_time_selected', { product: product, selling_plan: plan || null });
    }

    options.forEach(function (o) {
      o.addEventListener('click', function () { select(o, true); });
    });

    // What the customer chose, at the moment they chose to buy it. The add to
    // cart itself is Shopify's standard event; this only labels the offer.
    var form = root.closest('form');
    if (form) form.addEventListener('submit', function () {
      window.vxTrack('offer_added', { product: product, quantity: parseInt(qtyInput.value, 10) || 1, discount_pct: plan ? 0 : pct, selling_plan: plan || null });
    });

    if (down) down.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1;
      render();
    });
    if (up) up.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      render();
    });
    qtyInput.addEventListener('change', render);

    var checked = options.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0];
    select(checked || options[0]);
  }

  // Bottle view switcher (front / facts / directions): turns the label strip
  // in snippets/lx-bottle-photo.liquid.
  function initViews(root) {
    if (root.__vxViews) return;
    root.__vxViews = true;
    var strip = root.querySelector('[data-bottle-strip]');
    var btns = root.querySelectorAll('[data-show]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Each view's offset is on the strip (data-facts, data-side); the
        // label's panels differ in width.
        if (strip) strip.style.transform = 'translateX(' + (+strip.getAttribute('data-' + btn.dataset.show) || 0) + 'px)';
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      });
    });
  }

  // Product gallery (snippets/lx-buy.liquid): the track is a native scroll-snap
  // strip, so swipe, trackpad and arrow keys work without this. The script only
  // drives the thumbnails and arrows, and keeps them in step with the scroll.
  function initGallery(root) {
    if (root.__vxGallery) return;
    root.__vxGallery = true;
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = root.querySelectorAll('[data-gallery-go]');
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (!track) return;
    var count = track.children.length;
    var current = 0;

    function go(i) {
      i = Math.max(0, Math.min(count - 1, i));
      track.scrollTo({ left: i * track.clientWidth });
    }
    function sync() {
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t) {
        if (+t.dataset.galleryGo !== i) { t.removeAttribute('aria-current'); return; }
        t.setAttribute('aria-current', 'true');
        // Keep the active thumb in view when the row is wider than the column.
        var row = t.parentNode;
        if (row.scrollWidth > row.clientWidth) row.scrollLeft = t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === count - 1;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(+t.dataset.galleryGo); });
    });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('scroll', sync, { passive: true });
    current = -1;
    sync();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-purchase]').forEach(init);
    (scope || document).querySelectorAll('[data-views]').forEach(initViews);
    (scope || document).querySelectorAll('[data-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
